export var environment = {
    USER_DATA_FILE_PATH: 'https://liveschool.chooseyourreader.com/api/v8/storage/excel/exports/',
    SERVER_IMAGE_PATH: "https://liveschool.chooseyourreader.com/api/v8/public/upload/",
    API_URL: "https://liveschool.chooseyourreader.com/api/v8/public/index.php/api/",
    production: false
};
